import { Component } from 'react';

class SleepDisorderScreening extends Component {
  render() {
    return <h1>Sleep Disorder Screening</h1>;
  }
}

export default SleepDisorderScreening;
